import { WaterMonitoring } from '../../models/types/waterMonitoring';
import { atom } from 'jotai';

export const waterMonitoring = atom<WaterMonitoring[] | null>(null);